import type { FunctionComponent } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { Stack, Text } from '@atlaskit/primitives';
import Image from '@atlaskit/image';
import Heading from '@atlaskit/heading';

import LockImage from '#assets/lock.svg';
import { NoAccessError } from '#definitions/errors';
import { imageContainerStyling } from './ErrorPage';

const errorMessages = defineMessages({
  noAccessHeading: {
    id: 'error.noAccess.heading',
    defaultMessage: "You don't have access to this app.",
    description: 'The user does not have permissions to use this app',
  },
  noAccessDescription: {
    id: 'error.noAccess.description',
    defaultMessage:
      'This application is in development - only the owner of this application may grant it access to their account',
    description:
      'The user does not have permissions to use this app. Only the owner / developer of this application is able to give access to accounts.',
  },
});

const NoAccessErrorPage: FunctionComponent<NoAccessError> = () => (
  <Stack alignInline={'center'} space={'space.100'}>
    <Image style={imageContainerStyling} src={LockImage} alt="lock image" />
    <Heading size={'large'}>You don't have access to this app.</Heading>
    <Text align={'center'} color={'color.text.accent.gray'}>
      <FormattedMessage {...errorMessages.noAccessDescription} />
    </Text>
  </Stack>
);

export default NoAccessErrorPage;
